<template>

        <v-dialog
                v-model="dialog"
                hide-overlay
                width="auto "
                :fullscreen="$vuetify.breakpoint.xsOnly"
                transition="dialog-bottom-transition"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <button
                                v-bind="attrs"
                                v-on="on"
                                @click="startEdit"
                                class="td_title btn btn-link"
                                :disabled="note.email!==user.email"
                        >
                            <i class="far fa-pencil"></i>
                        </button>
                    </template>
                    <span>Edit Note</span>
                </v-tooltip>
            </template>
            <v-card style="min-width: 450px">
                <v-toolbar dark color="primary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title>Edit note</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>

                <v-container class="grey lighten-5" style="padding-left: 10%; padding-right: 10%">
                    <v-row>
                        <v-textarea
                                v-model="noteText"
                                label="Edit note"
                        ></v-textarea>
                    </v-row>
                    <v-row align="center" justify="center">
                        <v-btn
                                color="secondary"
                                text
                                @click="close"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                                color="primary"
                                text
                                @click="editNote"
                        >
                            Save
                        </v-btn>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

</template>

<script>
    import store from "@/store";
    import affiliatesApi from "@/api/affiliates";

    export default {
        data: () => ({
            dialog: false,
            noteText: ''
        }),
        props: {
            note: Object,
            user: Object,
            isDialog: Boolean
        },
        async mounted() {
            this.dialog = this.isDialog;
            this.noteText = this.note.note;
        },
        methods:{
          startEdit() {
            this.dialog = true;
          },

          async editNote() {
            try {
                await affiliatesApi.updateNote({note: this.noteText, id: this.note.id, isDelete: false});
                console.log(this.note.id, this.noteText);
                store.dispatch('alert/ALERT_SUCCESS', `Note was updated`, {root: true});
                this.$emit('createNote', '')
            } catch (e) {
                store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
            }

            setTimeout(() => {
                store.dispatch('alert/ALERT_REMOVE', ``, {root: true});
            }, 3000);

            this.dialog = false;
          },

          close() {
              this.noteText = this.note.note;
              this.dialog = false;
          },
        }
    }
</script>

<style scoped lang="sass">
</style>
